import { render } from "./BasicGUI.vue?vue&type=template&id=7605c518"
import script from "./BasicGUI.vue?vue&type=script&lang=js"
export * from "./BasicGUI.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__